import { Card, Form, Select, Input, DatePicker, Button, message, Space } from 'antd';
import dayjs from 'dayjs';
import { addLicenseAPI } from '@/apis/license';
import { useEffect, useState, useCallback } from 'react';

const { Option } = Select;

const LicenseAdd = () => {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  const genLicense = useCallback(()=>{
    const chars = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789abcdefghjkmnpqrstuvwxyz'; // 去除易混淆字符
    let s='';
    for(let i=0;i<15;i++){
      s += chars[Math.floor(Math.random()*chars.length)];
    }
    return s;
  },[]);

  // 初始化自动填入
  useEffect(()=>{
    form.setFieldsValue({ license: genLicense() });
  },[form, genLicense]);

  const onFinish = async (values)=>{
    const { appSource, license, canUseDate, info } = values;
    const ts = canUseDate ? Math.floor(canUseDate.valueOf()/1000) : null;
    try {
      setSubmitting(true);
  await addLicenseAPI({ appSource, license, canUseDate: ts, info });
      message.success('新增成功');
  const newCode = genLicense();
  form.resetFields();
  form.setFieldsValue({ license: newCode });
    } catch(e){
      console.error(e);
      message.error('新增失败');
    } finally { setSubmitting(false); }
  };

  return (
    <Card title="新增许可证">
      <Form form={form} labelCol={{ span: 6 }} wrapperCol={{ span: 14 }} onFinish={onFinish}>
        <Form.Item name="appSource" label="类型" rules={[{ required:true, message:'请选择类型'}]}>
          <Select placeholder="选择类型">
            <Option value="design">design</Option>
            <Option value="execute">execute</Option>
            <Option value="manager">manager</Option>
          </Select>
        </Form.Item>
        <Form.Item label="License" required>
          <Space.Compact style={{ width:'100%' }}>
            <Form.Item name="license" noStyle rules={[{ required:true, message:'请输入许可证字符串'}, { len:15, message:'长度需为15位'}]}>
              <Input placeholder="自动生成，可修改" maxLength={15} autoComplete="off" />
            </Form.Item>
            <Button type="default" onClick={()=>{
              const newL = genLicense();
              form.setFieldsValue({ license: newL });
            }} disabled={submitting}>再生成</Button>
          </Space.Compact>
        </Form.Item>
        <Form.Item name="canUseDate" label="有效期至" rules={[{ required:true, message:'请选择日期'}]}>
          <DatePicker showTime style={{ width:'100%' }} disabledDate={(d)=> d && d < dayjs().startOf('day')} />
        </Form.Item>
        <Form.Item name="info" label="备注" rules={[]}> 
          <Input.TextArea rows={3} maxLength={200} placeholder="可选备注" />
        </Form.Item>
        <Form.Item wrapperCol={{ span:14, offset:6 }}>
          <Button type="primary" htmlType="submit" loading={submitting}>提交</Button>
          <Button style={{marginLeft:12}} onClick={()=>form.resetFields()} disabled={submitting}>重置</Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default LicenseAdd;
